"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./PricingCards.scss");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Tooltip = _interopRequireDefault(require("../Tooltip/Tooltip"));
var _useScreenSize = require("../../utils/hooks/useScreenSize");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const PricingCard = _ref => {
  let {
    content,
    selected,
    setSelected,
    regionBlockedPricingCardText,
    regionBlocked = false
  } = _ref;
  const {
    title,
    description,
    price,
    currency,
    discount,
    terms,
    discountAmount,
    priceDescription,
    sku,
    priceType,
    tooltipContent,
    taxInformationLabel,
    taxPrice
  } = content;
  const updateCardSelection = sku => {
    setSelected(sku);
  };
  const {
    width
  } = (0, _useScreenSize.useScreenSize)();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `ter-pricing-card ${regionBlocked ? "ter-pricing-card--region-blocked" : "ter-pricing-card--region-available"}  ${selected === sku ? "ter-pricing-card--selected" : ""}`,
    onClick: () => !regionBlocked ? updateCardSelection(sku) : () => {},
    style: regionBlocked && width < 600 && !terms ? {
      height: "140px"
    } : regionBlocked && width < 600 && terms ? {
      height: "160px"
    } : regionBlocked && width > 600 && terms ? {
      height: "140px"
    } : {}
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-pricing-card__content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-pricing-card__content--top",
    style: regionBlocked && width < 600 ? {
      gridTemplateRows: "1fr 1fr"
    } : {}
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "ter-pricing-card__title"
  }, title), /*#__PURE__*/_react.default.createElement("p", {
    className: "ter-pricing-card__description"
  }, description), !regionBlocked && !priceType && /*#__PURE__*/_react.default.createElement("p", {
    className: "ter-pricing-card__price"
  }, `${price} ${currency}`), !regionBlocked && priceType && /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-pricing-card__price"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "ter-pricing-card__price"
  }, `${price} ${currency}/`), /*#__PURE__*/_react.default.createElement("p", {
    className: "ter-pricing-card__price--type"
  }, priceType)), !regionBlocked && /*#__PURE__*/_react.default.createElement("p", {
    className: "ter-pricing-card__price-description"
  }, priceDescription)), /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-pricing-card__term-container",
    style: regionBlocked ? {
      flexDirection: "column",
      alignItems: "flex-start"
    } : {}
  }, regionBlocked && /*#__PURE__*/_react.default.createElement("p", {
    className: "ter-pricing-card__term-container--region-blocked"
  }, regionBlockedPricingCardText), regionBlocked && /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-pricing-card__term-container--tooltip-region-blocked"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "ter-pricing-card__term-container--text"
  }, terms), tooltipContent && /*#__PURE__*/_react.default.createElement(_Tooltip.default, tooltipContent)), !regionBlocked && /*#__PURE__*/_react.default.createElement("p", {
    className: "ter-pricing-card__term-container--text"
  }, terms), tooltipContent && !regionBlocked && /*#__PURE__*/_react.default.createElement(_Tooltip.default, tooltipContent))));
};
const PricingCards = _ref2 => {
  let {
    content = {},
    contentfulId,
    selected,
    setSelected,
    regionBlockedPricingCardText,
    regionBlocked
  } = _ref2;
  const {
    cards
  } = content;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-pricing-cards"
  }, cards?.map((card, index) => {
    return /*#__PURE__*/_react.default.createElement(PricingCard, {
      key: `pricing-card-${index}`,
      content: card,
      contentfulId: contentfulId,
      selected: selected,
      setSelected: setSelected,
      regionBlockedPricingCardText: regionBlockedPricingCardText,
      regionBlocked: regionBlocked
    });
  }));
};
var _default = PricingCards;
exports.default = _default;